<template>
  <section class="customer-detail-placeholder">
    <article class="customer-detail-card">
      <header class="customer-detail-card-header">
        <h4>{{ title }}</h4>
      </header>
      <p>
        Esta sección estará disponible en la siguiente iteración.
      </p>
    </article>
  </section>
</template>

<script>
export default {
  name: 'SupplierDetailPlaceholderTab',
  props: {
    title: {
      type: String,
      default: 'Sección',
    },
  },
};
</script>
